<template>
    <div>
        <b-overlay rounded="sm">
            <b-row>
                <b-form-group label="Regione" label-for="regione" class="text-left pl-3">
                    <b-form-select 
                        class="my-1 shadow_6 text-capitalize"
                        v-model="filters.regione"
                        @change="getIframeUrl"
                    >
                        <b-form-select-option :value="null" disabled>Seleziona</b-form-select-option>
                        <b-form-select-option v-for="regione in regioni" :key="regione.value" :value="regione.value">
                            {{ regione.text }}
                        </b-form-select-option>
                    </b-form-select>
                </b-form-group>
            </b-row>
            <div>
                <iframe class="mb-5" :src="iframeUrl" frameborder="0" width="100%" height="1600" allowTransparency></iframe>
            </div>
        </b-overlay>
    </div>
</template>

<script>
import { adminService } from "@/_services";

export default {
    name: "DatiApp",
    data() {
        return {
            filters: {
                regione: null,
            },
            iframeUrl: "",
            regioni: [
                { text: "Generale", value: 11 },
                { text: "Abruzzo", value: 12 },
                { text: "Puglia", value: 9 },
                { text: "Sicilia", value: 13 },
                { text: "Umbria", value: 14 },
                { text: "Molise", value: 15 },
                { text: "Veneto", value: 16 }
            ]
        };
    },
    methods: {
        getIframeUrl() {
            const selectedId = this.filters.regione || 11;
            this.iframeUrl = adminService.generateIframeUrl(selectedId);
        }
    },
    mounted() {
        this.getIframeUrl();
    }
};
</script>
